import React from 'react';
import { LivingDocuments } from 'components/LivingDocuments';

export const MovingInOut = () => (
  <LivingDocuments category="moving-in-out" />
);
